"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Can be replaced with padStart after IE deprecation
var zeroify = function (value) {
    return value <= 9 && value >= 0 ? "0".concat(value) : value.toString();
};
exports.default = zeroify;
